import { default as FinanceSetting } from "Lib/API/FinanceSetting/FinanceSetting";
import { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
const useTemplateReplacement = (htmlContent, getAccessTokenSilently,type,disable = false) => {
  const [tokenList, setTokenList] = useState([]);
  const [content, setContent] = useState("");


  const getTemplateTokens = async () => {
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.getTemplateTokens(token,type);
      const tokens = response?.result
      setTokenList(tokens);
      
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
  };

  useEffect(() => {
    if(disable || !type) return;
    getTemplateTokens();
  }, []);



  useEffect(() => {
    if(disable) return;
    const replacedContent = tokenList.reduce((accumulator, token) => {
      return accumulator?.replaceAll(`${token.value}`, `{{${token.name}}}`);
    }, htmlContent);
    setContent(replacedContent);
  }, [tokenList, htmlContent]);

  return { content };


};

export default useTemplateReplacement;